import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        // Intentamos recuperar el token y el usuario del localStorage al iniciar
        token: localStorage.getItem('access_token_cf') || null,
        // Parseamos el string del usuario de vuelta a un objeto
        user: JSON.parse(localStorage.getItem('user_cf')) || null,
        // Guardamos la fecha de expiración calculada
        expiration: localStorage.getItem('expiration_cf') || null,
        loading: false 
    }),

    getters: {
        isAuthenticated: (state) => !!state.token && !!state.user,
        // Getter para obtener los roles fácilmente
        getUserRoles: (state) => state.user?.roles || []
    },

    actions: {
        // Modificamos para recibir tanto el token como los datos del usuario
        // Recibimos expires_in (segundos) desde el backend expiresIn
        login(token, userData, expiresIn) {
            this.token = token;
            this.user = userData;
            
            // Calculamos la fecha/hora exacta de muerte del token
            const expirationTime = Date.now() + (expiresIn * 1000);
            this.expiration = expirationTime;
            // Guardamos ambos en el disco
            localStorage.setItem('access_token_cf', token);
            localStorage.setItem('user_cf', JSON.stringify(userData));
            localStorage.setItem('expiration_cf', expirationTime);
        },

        // Mantenemos setToken por si necesitas actualizarlo por separado
        setToken(token) {
            this.token = token;
            localStorage.setItem('access_token_cf', token);
        },

        // Nueva acción para actualizar solo los datos del usuario
        setUser(userData) {
            this.user = userData;
            localStorage.setItem('user_cf', JSON.stringify(userData));
        },

        logout() {
            this.token = null;
            this.user = null;
            // Limpiamos todo el rastro en el disco
            localStorage.removeItem('access_token_cf');
            localStorage.removeItem('user_cf');
        },

        isTokenValid() {
            // Un token es válido solo si también tenemos los datos del usuario
            return !!this.token && !!this.user;
        },
        async extendSession(AuthService) {
        try {
            const response = await AuthService.refresh(); // Llama a tu ruta /refresh de Laravel
            const { access_token, user, expires_in } = response.data;
            
            // Usamos la misma lógica de login para resetear el contador
            this.login(access_token, user, expires_in);
            return true;
        } catch (error) {
            console.error("No se pudo refrescar el token", error);
            return false;
        }
    }
    }
});